import type { Persona, Theme } from './personas';

export type VersionKey = 'healing' | 'ritual' | 'clarity';

export interface VersionProfile {
  key: VersionKey;
  persona: Persona;
  theme: Theme;
  name: string;
  shortName: string;
  promise: string;
  audience: string;
  sampleConcern: string;
}

export const VERSION_PROFILES: Record<VersionKey, VersionProfile> = {
  healing: {
    key: 'healing',
    persona: 'luna',
    theme: 'morandi',
    name: '療癒陪伴版',
    shortName: '陪伴',
    promise: '給情感、關係與心事傾訴使用者，一進來就像被溫柔接住。',
    audience: '適合情感陪伴、關係占卜、女性客群與高復訪內容。',
    sampleConcern: '我最近對感情很迷惘，不知道該不該繼續。',
  },
  ritual: {
    key: 'ritual',
    persona: 'orion',
    theme: 'mystic',
    name: '神秘儀式版',
    shortName: '儀式',
    promise: '強化沉浸感、付費感與占卜師權威，像進入一場深夜讀牌。',
    audience: '適合主打儀式感、命運感、單次付費解讀與高轉換 CTA。',
    sampleConcern: '我一直覺得某段關係還沒結束，但我不知道該不該回頭。',
  },
  clarity: {
    key: 'clarity',
    persona: 'sage',
    theme: 'minimal',
    name: '理性分析版',
    shortName: '分析',
    promise: '把塔羅變成清楚的決策輔助，適合不想太迷信但想被點醒的人。',
    audience: '適合成熟客群、自我理解、職涯/關係決策與高信任品牌。',
    sampleConcern: '我卡在一個重要決定裡，理智知道答案，情緒卻一直拉住我。',
  },
};

export const VERSION_KEYS: VersionKey[] = ['healing', 'ritual', 'clarity'];

export function isVersionKey(value: string | undefined): value is VersionKey {
  return value === 'healing' || value === 'ritual' || value === 'clarity';
}

export function versionFromPersona(persona: Persona): VersionKey {
  if (persona === 'orion') return 'ritual';
  if (persona === 'sage') return 'clarity';
  return 'healing';
}
